// extracted by mini-css-extract-plugin
export default {"TableContainer":"_TableContainer--hx824","ShowBordersTable":"_ShowBordersTable--_W2Fa","HiddenBordersTable":"_HiddenBordersTable--Ud6bi","EditableTable":"_EditableTable--h7nUW"};